<template>
  <svg :style="style" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Article">
      <path id="Vector"
        d="M20.25 4.25H3.75C3.35218 4.25 2.97064 4.40804 2.68934 4.68934C2.40804 4.97064 2.25 5.35218 2.25 5.75V19.25C2.25 19.6478 2.40804 20.0294 2.68934 20.3107C2.97064 20.592 3.35218 20.75 3.75 20.75H20.25C20.6478 20.75 21.0294 20.592 21.3107 20.3107C21.592 20.0294 21.75 19.6478 21.75 19.25V5.75C21.75 5.35218 21.592 4.97064 21.3107 4.68934C21.0294 4.40804 20.6478 4.25 20.25 4.25ZM16.5 16.25H7.5C7.30109 16.25 7.11032 16.171 6.96967 16.0303C6.82902 15.8897 6.75 15.6989 6.75 15.5C6.75 15.3011 6.82902 15.1103 6.96967 14.9697C7.11032 14.829 7.30109 14.75 7.5 14.75H16.5C16.6989 14.75 16.8897 14.829 17.0303 14.9697C17.171 15.1103 17.25 15.3011 17.25 15.5C17.25 15.6989 17.171 15.8897 17.0303 16.0303C16.8897 16.171 16.6989 16.25 16.5 16.25ZM16.5 13.25H7.5C7.30109 13.25 7.11032 13.171 6.96967 13.0303C6.82902 12.8897 6.75 12.6989 6.75 12.5C6.75 12.3011 6.82902 12.1103 6.96967 11.9697C7.11032 11.829 7.30109 11.75 7.5 11.75H16.5C16.6989 11.75 16.8897 11.829 17.0303 11.9697C17.171 12.1103 17.25 12.3011 17.25 12.5C17.25 12.6989 17.171 12.8897 17.0303 13.0303C16.8897 13.171 16.6989 13.25 16.5 13.25ZM16.5 10.25H7.5C7.30109 10.25 7.11032 10.171 6.96967 10.0303C6.82902 9.88968 6.75 9.69891 6.75 9.5C6.75 9.30109 6.82902 9.11032 6.96967 8.96967C7.11032 8.82902 7.30109 8.75 7.5 8.75H16.5C16.6989 8.75 16.8897 8.82902 17.0303 8.96967C17.171 9.11032 17.25 9.30109 17.25 9.5C17.25 9.69891 17.171 9.88968 17.0303 10.0303C16.8897 10.171 16.6989 10.25 16.5 10.25Z"
        :fill="color" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'recommand-module',
  props: {
    color: {
      type: String,
      default: 'white'//#212227
    },
    fontSize: {
      type: String,
      default: '24px'
    }
  },
  data() {
    return {
      style: {
        'vertical-align': 'middle',
        overflow: 'hidden',
        width: '1em',
        height: '1em',
        'font-size': this.fontSize
      }
    }
  }
}
</script>